import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TableEmptyStateConfig } from './table-empty-state-config';
import { ButtonComponent } from '../../buttons/button/button.component';
import { ButtonTypeEnum } from '../../buttons/button/button-type.enum';

@Component({
  selector: 'app-table-empty-state',
  templateUrl: './table-empty-state.component.html',
  styleUrls: ['./table-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, ButtonComponent]
})
export class TableEmptyStateComponent {
  @Input() config!: TableEmptyStateConfig;
  @Output() buttonClicked = new EventEmitter();
  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
